export const urlRegex = /href=["']?(https?:\/\/[^\s"'>]+)/;
export const globalUrlRegex = /href=["']?(https?:\/\/[^\s"'>]+)/g;
export const plainUrlRegex = /(https?:\/\/[^\s"'>]+)/;
export const globalPlainUrlRegex = /(https?:\/\/[^\s"'>]+)/g;
export const iframeRegex = /<iframe[^>]*src=["']([^"']+)["'][^>]*><\/iframe>/;
export const dataUrlRegex = /<iframe[^>]*data-url=["']([^"']+)["'][^>]*>/;
export const urlAnchorRegex = /<a[^>]*href=["'](https?:\/\/[^"']+)["'][^>]*>.*?<\/a>/gi;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phoneNumber = /^(\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/;
export const zipCode = /^[0-9]{5}(?:-[0-9]{4})?$/;